export enum Currency {
  NOK = 'NOK'
}
